import UserCreate from './UserCreate'

export default UserCreate
